import React from "react";
import EntriesTable from "./EntriesTable";
import WagerTypes from "../constants/WagerTypes";

const Trifecta = ({
  raceInfo,
  entriesInfo,
  idTrifecta,
  idBox,
  addToCart,
  disabledAll,
  checkBoxState,
}) => {
  return (
    <>
      <div
        className="tab-pane fade show active"
        id="Trifecta"
        role="tabpanel"
        aria-labelledby="Trifecta"
      >
        <EntriesTable
          raceInfo={raceInfo}
          entriesInfo={entriesInfo}
          wt={WagerTypes.TRIFECTA.name}
          idWT={idTrifecta}
          idBox={idBox}
          addToCart={addToCart}
          disabledAll={disabledAll}
          checkBoxState={checkBoxState}
        />
      </div>
    </>
  );
};

export default Trifecta;
